import PastTrips from './PastTripsContainer';

export default PastTrips;
